import {
  PERSONA_BRIEF_AGE_RANGES,
  PERSONA_BRIEF_DURATIONS,
  PERSONA_BRIEF_GENDERS,
  PERSONA_BRIEF_HOOK_PACKAGES,
} from "@nexus/contracts";
import type { TFunction } from "i18next";

/** Closed lists for brief chrome Selects. Persist these contract strings (hook package is 1 | 4). */
export const PERSONA_BRIEF_DURATION_OPTIONS = PERSONA_BRIEF_DURATIONS;
export const PERSONA_BRIEF_AGE_RANGE_OPTIONS = PERSONA_BRIEF_AGE_RANGES;
export const PERSONA_BRIEF_GENDER_OPTIONS = PERSONA_BRIEF_GENDERS;
export const PERSONA_BRIEF_HOOK_PACKAGE_OPTIONS = PERSONA_BRIEF_HOOK_PACKAGES;

export type PersonaBriefHookPackageOption = (typeof PERSONA_BRIEF_HOOK_PACKAGE_OPTIONS)[number];

const CLOSED_LIST_LABELS: Record<string, readonly [string, string]> = {
  "15 seconds": ["personaOpportunities.scripts.briefs.duration15", "15 seconds"],
  "30 seconds": ["personaOpportunities.scripts.briefs.duration30", "30 seconds"],
  "60 seconds": ["personaOpportunities.scripts.briefs.duration60", "60 seconds"],
  "18-24": ["personaOpportunities.scripts.briefs.age18", "18-24"],
  "25-34": ["personaOpportunities.scripts.briefs.age25", "25-34"],
  "35-44": ["personaOpportunities.scripts.briefs.age35", "35-44"],
  "45+": ["personaOpportunities.scripts.briefs.age45", "45+"],
  "Open To All": ["personaOpportunities.scripts.briefs.ageOpen", "Open To All"],
  Male: ["personaOpportunities.scripts.briefs.genderMale", "Male"],
  Female: ["personaOpportunities.scripts.briefs.genderFemale", "Female"],
  Both: ["personaOpportunities.scripts.briefs.genderBoth", "Both"],
};

/** Keep stored contract values; translate the visible label. Unknown values stay as stored. */
export function translatePersonaBriefClosedListValue(t: TFunction, value: string): string {
  const entry = CLOSED_LIST_LABELS[value];
  if (!entry) return value;
  return t(entry[0], entry[1]);
}

/** Keep a stored value visible in the list until the user picks a closed option. */
export function withCurrentOption(options: readonly string[], current: string): string[] {
  if (!current || options.includes(current)) return [...options];
  return [current, ...options];
}
